import React, { useState, useRef, useEffect } from 'react';
import useDarkMode from '../../hooks/useDarkMode';
import styles from './SideControlPanel.module.css';

// Import the images
import jediIcon from '../../assets/jedi_icon.png';
import sithIcon from '../../assets/sith_icon.png';

export default function SideControlPanel() {
  const [open, setOpen] = useState(false);
  const panelRef = useRef();
  const [isDark, setIsDark] = useDarkMode();

  const togglePanel = () => setOpen(prev => !prev);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (panelRef.current && !panelRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  // Next mode logic
  const nextModeIsDark = !isDark;
  const iconToShow = nextModeIsDark ? sithIcon : jediIcon;
  const modeText = nextModeIsDark ? 'Dark Mode' : 'Light Mode';

  return (
    <>
      <button
        className={styles.expandButton}
        onClick={togglePanel}
        aria-label="Open control panel"
      >
        +
      </button>

      <div
        ref={panelRef}
        className={`${styles.controlPanel} ${open ? styles.open : ''}`}
      >
        <h3>{modeText}</h3>
        <button onClick={() => setIsDark(nextModeIsDark)} className={styles.iconButton}>
          <img
            src={iconToShow}
            alt={modeText}
            className={styles.icon}
          />
        </button>
      </div>
    </>
  );
}
